import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export type LatestAchievementsSkeletonProps = {
  count?: number;
};

export const LatestAchievementsSkeleton: FC<LatestAchievementsSkeletonProps> = ({ count = 3 }) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      {Array.from({ length: count }).map((_, i) => (
        <ThemedSkeleton 
          key={i} 
          variant="rectangular" 
          width={110} 
          height={180} 
          sx={{ 
            borderRadius: '12px', 
            borderBottomLeftRadius: '48px', 
            borderBottomRightRadius: '48px', 
            flexShrink: 0 
          }} 
        />
      ))}
    </Stack>
  );
};

